import * as Constants from "./constants";

export const togglePanel = (text) => ({
  type: Constants.TOGGLE_PANEL,
  payload: {
    text,
  },
});

export const toggleSidebar = (isOpen) => ({
  type: Constants.TOGGLE_SIDEBAR,
  payload: {
    isOpen,
  },
});

export const setSidebarItems = (role) => ({
  type: Constants.SET_SIDEBAR_ITEMS,
  payload: {
    role,
  },
});

export const initMenu = (menu) => ({
  type: Constants.MENU,
  payload: {
    menu,
  },
});

export const breadcrumbs = (breadcrumbs) => ({
  type: Constants.BREADCRUMBS,
  payload: {
    breadcrumbs,
  },
});

export const setLoading = (isLoading = false, loadingText = "") => ({
  type: Constants.LOADING,
  payload: {
    isLoading,
    loadingText,
  },
});

export const setAuth = (auth) => ({
  type: Constants.AUTH,
  payload: {
    auth,
  },
});

export const setApiError = (error = null) => ({
  type: Constants.API_ERROR,
  payload: {
    error,
  },
});

export const clearApiError = () => setApiError(null);
